import accountSaga from '../pages/MyAccounts/sagas';

export default accountSaga;
